import React, { useEffect } from "react";
import {
  StyleSheet,
  View,
  ImageBackground,
  TouchableOpacity,
} from "react-native";
import { Text, Button } from "react-native-paper";
import Button2 from "../common/Button";
import { connect } from "react-redux";
import { actionCreators } from "../test/action";
import PageContainer from "../common/PageContainer";
import routes from "../routing/routes";
import displayName from "../common/displayName";
import { actionCreators as actionCreatorsResults } from "../containers/Results/action";
import { actionCreators as actionCreatorsFooterMenu } from "../FooterMenu/action";
import ParrotBox from "../containers/ParrotBox";
import windowWidth from "../common/windowWidth";
import { iconRight } from "../common/ModalIcons";
import { blackColor } from "../common/colors";
import SliderBox from "../containers/SliderBox";
import { getOnlyOneDominateColor } from "./../common/helpers/onlyTwoDominateColors";
import questions from "../containers/SingleTest/questions";
import JakInterpretowacWynikImage from "../assets/JakInterpretowacWynik.png";
import TeoriaKolorow from "../assets/TeoriaKolorow.png";
import CzymJestTestLoriini from "../assets/CzymJestTestLoriini.png";
import t from "../translations";

const AboutRoute = (props) => {
  useEffect(() => {
    props.fetchResult();
  }, []);

  const onClickGoToSettings = () => {
    props.navigation.navigate(routes.Settings);
  };

  const onClickGoToKnowladgeColorTheory = () => {
    props.navigation.navigate(routes.KnowladgeColorTheory);
  };

  const onClickGoToKnowladgeWhatIsLoriiniTest = () => {
    props.navigation.navigate(routes.KnowladgeWhatIsLoriiniTest);
  };

  const onClickGoToKnowladgeHowInterprateResult = () => {
    props.navigation.navigate(routes.KnowladgeHowInterprateResult);
  };
  const answers = props.answers;
  const result = { R: 0, B: 0, G: 0, Y: 0 };

  {
    answers &&
      answers.map((o) => {
        result[questions[o.question - 1].colors[0]] =
          result[questions[o.question - 1].colors[0]] + (100 - o.value);
        result[questions[o.question - 1].colors[1]] =
          result[questions[o.question - 1].colors[1]] + o.value;
      });
  }

  const dominate = getOnlyOneDominateColor(result)[0];
  return (
    props.activeFotterMenu === 0 && (
      <PageContainer
        {...props}
        noBackground={true}
        isSettingsIcon={true}
        onClickGoToSettings={onClickGoToSettings}
      >
        <Text style={styles.welcome}>
          {t("homeRoute_welcome")} {displayName(props?.user)}!
        </Text>
        <View style={styles.container}>
          {!props.answers ? (
            <>
              <Text style={styles.textDescription}>
                {t("homeRoute_textDescription")}
              </Text>
              <Button2
                onPress={() => props.navigation.navigate(routes.ModalTest)}
                value={t("homeRoute_button2")}
                style={{ marginTop: 30, marginBottom: 30 }}
              />
            </>
          ) : (
            <>
              <ParrotBox dominate={dominate} />
              <View style={styles.buttonsContainer}>
                <Button
                  contentStyle={{ flexDirection: "row-reverse" }}
                  icon={iconRight}
                  mode="text"
                  style={styles.button}
                  onPress={() => props.setActiveFooterMenu(1)}
                >
                  {t("homeRoute_showResult")}
                </Button>
                <Button
                  contentStyle={{ flexDirection: "row-reverse" }}
                  icon="refresh"
                  mode="text"
                  style={styles.button}
                  onPress={() => props.navigation.navigate(routes.ModalTest)}
                >
                  {t("homeRoute_repeatTest")}
                </Button>
              </View>
            </>
          )}
          {!!props.answers && (
            <ImageBackground
              source={JakInterpretowacWynikImage}
              resizeMode="cover"
              style={{ flex: 1, justifyContent: "center", margin: 30 }}
            >
              <TouchableOpacity
                onPress={onClickGoToKnowladgeHowInterprateResult}
              >
                <View style={styles.boxSmall}>
                  <View style={styles.titleWrapper}>
                    <Text style={styles.title}>
                      {t("homeRoute_howInterprateResult")}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            </ImageBackground>
          )}
          <ImageBackground
            source={CzymJestTestLoriini}
            resizeMode="cover"
            style={{ flex: 1, justifyContent: "center", margin: 30 }}
          >
            <TouchableOpacity onPress={onClickGoToKnowladgeWhatIsLoriiniTest}>
              <View style={styles.boxLarge}>
                <View style={styles.titleWrapper}>
                  <Text style={styles.title}>
                    {t("homeRoute_whatIsLoriiniTest")}
                  </Text>
                </View>
              </View>
            </TouchableOpacity>
          </ImageBackground>
          {!!props.answers && (
            <ImageBackground
              source={TeoriaKolorow}
              resizeMode="cover"
              style={{ flex: 1, justifyContent: "center", margin: 30 }}
            >
              <TouchableOpacity onPress={onClickGoToKnowladgeColorTheory}>
                <View style={styles.boxSmall}>
                  <View style={styles.titleWrapper}>
                    <Text style={styles.title}>
                      {t("homeRoute_colorsTheory")}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            </ImageBackground>
          )}
          {/* <View>
            <Text style={styles.titleAboutCommunication}>O komunikacji</Text>
          </View> */}

          <SliderBox navigation={props.navigation} />
        </View>
      </PageContainer>
    )
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  const answers = state.test ? state.test : null;
  return { user, answers };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...actionCreatorsResults,
  ...actionCreatorsFooterMenu,
})(AboutRoute);

const marginBox = 10;
const styles = StyleSheet.create({
  boxLarge: {
    width: windowWidth() - 2 * marginBox,
    height: 252,
    marginLeft: marginBox,
    marginRight: marginBox,
    marginTop: 5,
    marginBottom: 5,
    borderWidth: 0,
    alignItems: "flex-start",
    justifyContent: "flex-end",
    padding: 20,
  },
  boxSmall: {
    width: windowWidth() - 2 * marginBox,
    height: 304,
    marginLeft: marginBox,
    marginRight: marginBox,
    marginTop: 5,
    marginBottom: 5,
    borderWidth: 0,
    alignItems: "flex-start",
    justifyContent: "flex-end",
    padding: 20,
  },
  slider: {
    width: windowWidth(),
    height: 104,
    marginLeft: marginBox,
    marginRight: marginBox,
    marginTop: 5,
    marginBottom: 5,
    borderWidth: 0,
    alignItems: "flex-start",
    justifyContent: "flex-end",
    padding: 20,
  },
  title: {
    fontSize: 14,
    padding: 10,
  },
  titleWrapper: {
    backgroundColor: "white",
    borderRadius: 2,
    borderWidth: 1,
    borderColor: "black",
  },
  container: {
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  buttonsContainer: {
    alignItems: "flex-end",
    marginRight: 30,
    width: windowWidth(),
  },
  button: {
    margin: 10,
    borderBottomWidth: 1.5,
    borderColor: "black",
  },
  welcome: {
    paddingLeft: 20,
    textAlign: "left",
    fontSize: 24,
    paddingBottom: 73,
    paddingTop: 24,
    lineHeight: 26,
    letterSpacing: 1.25,
    textTransform: "uppercase",
  },
  textDescription: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1.25,
  },
  titleAboutCommunication: {
    textTransform: "uppercase",
    fontSize: 16,
    color: blackColor,
    fontWeight: "bold",
    paddingTop: 30,
  },
});
